<template>
  <!-- //ROUTER IF MOBILE -->
  <ion-content class="d-flex wrapper" v-if="isMobile" >
    <NavBar />
      <div class="block block__browse">
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </ion-content> 
  <!-- //ROUTER IF MOBILE -->

  <!-- //ROUTER IF DESKTOP -->
  <section class="d-flex wrapper" v-else>
      <sidebar />
      <div class="block block__browse">
        <!-- <div> -->
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
        <!-- </div> -->
      </div>
  </section> 
  <!-- //ROUTER IF DESKTOP -->
</template>


<script>
import Sidebar from '../../module/sidebar/Sidebar'
import CatMixin from './CatMixin'
import { mapGetters } from 'vuex'
import NavBar from '../../module/Navbar'

export default {
  name:"browse",
    components:{
        Sidebar,
        NavBar
    },
    mixins: [
      CatMixin
    ],    
    data () {
      return {
      }
    },
    mounted(){
    },
  computed: {
    ...mapGetters([
    ])
  },
  methods : {           

  },
};
</script>
